/** DOM scope used for AskAsper; design-library CSS is scoped under this class. */
export const ASK_ASPER_SCOPE_CLASS = 'askasper-scope';

/** Id of the body-level portal root that all AskAsper overlays mount into. */
export const ASK_ASPER_PORTAL_ROOT_ID = 'askasper-portal-root';

/**
 * Single container for every AskAsper overlay (modals, dropdowns, popovers,
 * notifications). It is a direct child of <body> (so nothing is clipped by the
 * in-route shell's overflow:hidden) and carries `.askasper-scope` so the scoped
 * design-library stylesheet applies to portaled content too.
 */
export function getAskAsperPortalRoot(): HTMLElement {
    if (typeof document === 'undefined') {
        return undefined as unknown as HTMLElement;
    }

    let root = document.getElementById(ASK_ASPER_PORTAL_ROOT_ID);
    if (!root) {
        root = document.createElement('div');
        root.id = ASK_ASPER_PORTAL_ROOT_ID;
        root.classList.add(ASK_ASPER_SCOPE_CLASS);
        document.body.appendChild(root);
    }
    return root;
}
